// HomePage.js
import React from 'react';
import { Box, Grid, Typography, Link, Paper, Divider, Container } from '@mui/material';
import { Card, CardContent, CardActionArea, CardMedia } from '@mui/material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { SystemConstants } from '@datatox-bi/util';

const dashboards = [
    {
        category: 'Grupo 1',
        links: SystemConstants.LinksHome,
    },
];

const DashboardSummary = () => {
    const navigate = useNavigate();
    // Assumindo que você terá um array de objetos que representam seus resumos e gráficos
    const summaries = SystemConstants.Summaries;

    return (
        <Box sx={{ flexGrow: 1, margin: 5 }}>
            <Grid container spacing={3}>
                {summaries.map((summary, index) => (
                    <Grid id={summary.id} item xs={12} md={12} lg={12} key={index}>
                        <Card
                            sx={{
                                display: 'flex',
                                flexDirection: { xs: 'column', sm: 'column', md: 'row', lg: 'row', xl: 'row' },
                                alignItems: 'stretch',
                                justifyContent: 'space-between',
                            }}
                        >
                            <CardContent>
                                <Typography
                                    variant="h6"
                                    component="h3"
                                    onClick={() => navigate(`/${summary.id}`)}
                                    sx={{
                                        cursor: 'pointer', // Alterar cursor para indicar que é clicável
                                        '&:hover': {
                                            color: 'primary.main', // Mudar a cor ao passar o mouse
                                        },
                                    }}
                                >
                                    {summary.title}
                                </Typography>
                                <br />
                                <Typography variant="body2" justifyContent={'center'} align="justify">
                                    <div dangerouslySetInnerHTML={{ __html: summary.description }} />
                                </Typography>
                            </CardContent>
                            <CardMedia
                                onClick={() => navigate(`/${summary.id}`)}
                                component="img"
                                sx={{
                                    objectFit: 'contain',
                                    cursor: 'pointer',
                                    p: 1,
                                    m: 2,
                                    width: { xs: '100%', md: 400 }, // Largura fixa no layout maior
                                    height: 'auto', // Altura fixa para garantir alinhamento
                                    backgroundColor: '#f5f5f5', // Adiciona uma cor de fundo para imagens menores
                                    border: '1px solid #ccc', // Define uma borda ao redor da imagem
                                    // borderRadius: '2px', // Adiciona bordas arredondadas
                                }}
                                image={summary.previewUrl}
                                alt="Série histórica"
                            />
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

const HomePage = () => {
    return (
        <>
            <Box sx={{ flexGrow: 1 }}>
                <Paper elevation={0} square>
                    <Box px={3} py={2} marginLeft={3}>
                        <Typography variant="h4" gutterBottom>
                            Índice
                        </Typography>
                        <Grid container spacing={2}>
                            {dashboards.map((category, index) => (
                                <Grid item xs={12} md={12} key={index}>
                                    {category.links.map((link, linkIndex) => (
                                        <Box
                                            key={linkIndex}
                                            mb={1}
                                            sx={{
                                                marginLeft: 2,
                                                textDecoration: 'none',
                                                '&:hover': {
                                                    textDecoration: 'underline', // Destacar links ao passar o mouse
                                                    color: 'primary.main',
                                                },
                                            }}
                                        >
                                            <Link
                                                href={link.href}
                                                variant="h6"
                                                sx={{
                                                    textDecoration: 'none',
                                                }}
                                            >
                                                {link.title}
                                            </Link>
                                        </Box>
                                    ))}
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                </Paper>
            </Box>
            <Divider sx={{ marginLeft: 3, marginRight: 3 }} />
            <DashboardSummary />
            <Box sx={{ flexGrow: 1, margin: 5 }}>
                <Typography variant="body1" align="left">
                    O CIATox/RS e o CIAT/DF usam sistemas próprios, independentes.
                </Typography>
            </Box>
        </>
    );
};

export default HomePage;
